
<template>
    <div class="center">
      <vs-dialog v-model="active" width="700px">
        <template #header>
          <h4 class="not-margin">
              {{row.asignatura}}
          </h4>
        </template>
        <div v-if="mostrarHorarios == true">
            <md-card class="mb-3" v-for="(hor, i) in row.horarios" :key="i">
                <md-card-content>
                    <vs-row>
                        <vs-col sm="12" lg="6">
                            <p class="mb-0">Profesor: <strong>{{hor.docente}} </strong></p>
                        </vs-col>
                        <vs-col v-for="(time, j) in hor.horarios" :key="j" sm="12" lg="12" class="d-flex" style="align-items: center;margin: 10px 0 ">
                            <div>
                                <p class="mb-0"><strong>{{time.horario}}</strong></p>
                                <p class="mb-0">Cupo disponible: <strong>{{time.cupo ? time.cupo : '40'}} </strong></p>

                            </div>
                            
                            <vs-button
                                v-if="j == 0"
                                warn
                                flat
                                size="mini"
                                @click="postDesvincularse()"
                            >
                                DESVINCULAR
                            </vs-button>

                            <vs-button
                                v-if="row.status == 'disponible' && j != 0"
                                success
                                flat
                                size="mini"
                                @click="postVincularse()"
                            >
                                VINCULAR
                            </vs-button>
                        </vs-col>
                    </vs-row>
                </md-card-content>
            </md-card>
        </div>
        <div v-if="mostrarSinHorarios == true">
            <h4 class="text-center">No hay horarios disponibles</h4>
        </div>
      </vs-dialog>
    </div>
</template>

<script>
export default {
    props:[
    'value',
    'row',
    ],
    data(){
        return{
        active: false,
        mostrarHorarios: false,
        mostrarSinHorarios: false
        }
    },
    methods: {
        async postVincularse(){
            try { 
            }catch{
                
            }
        },
        postDesvincularse(){

        },
        validoInscripcion(){
            if(this.row.horarios[0]){
                this.mostrarHorarios = true
                this.mostrarSinHorarios = false
            }else{
                this.mostrarSinHorarios = true
                this.mostrarHorarios = false
            }
            // const materias = this.row.horarios
            // const boton = []
            // materias.forEach(item => {
            //     if(item.horarios[0]){
            //         const status = []
            //         item.horarios.forEach(i => {
            //             status.push(i.status)
            //         })
            //         boton.push(status.includes(false))
            //     }
            // });
            // this.boton = boton
            // console.log(boton)
        },
        
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        row(){
          this.validoInscripcion() 
        }
    }
}
</script>

<style>
    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }
</style>